// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Cneh","content":"styles_content__1G4Cz"};